import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import * as serviceWorker from './serviceWorker';
import App from './App';
import SignUpForm from './components/SignUpForm';
import SignUpDRPForm from './components/SignUpDRPForm';
import RequestARepForm from './components/RequestARepForm';
import UnsubscribeForm from './components/UnsubscribeForm';

// Reducers
import reducers from './reducers';

// Styling
import "./App.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

// Only run devtools in dev
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(
  applyMiddleware(reduxThunk)
);

// Redux
const store = createStore(
  reducers,
  enhancer
);

console.log("process.env.NODE_ENV", process.env.NODE_ENV);

if (process.env.NODE_ENV !== 'development') {
  if (document.getElementById('sign-up-form')) {
    ReactDOM.render( 
      <React.StrictMode>
        <Provider store={store}>
          <SignUpForm />
        </Provider>
      </React.StrictMode>,
      document.getElementById('sign-up-form')
    );
  }
  if (document.getElementById('sign-up-drp-form')) {
    ReactDOM.render( 
      <React.StrictMode>
        <Provider store={store}>
          <SignUpDRPForm />
        </Provider>
      </React.StrictMode>,
      document.getElementById('sign-up-drp-form')
    );
  }
  if (document.getElementById('request-a-rep')) {
    ReactDOM.render( 
      <React.StrictMode>
        <Provider store={store}>
          <RequestARepForm />
        </Provider>
      </React.StrictMode>,
      document.getElementById('request-a-rep')
    );
  }
  if (document.getElementById('unsubscribe-form')) {
    ReactDOM.render( 
      <React.StrictMode>
        <Provider store={store}>
          <UnsubscribeForm />
        </Provider>
      </React.StrictMode>,
      document.getElementById('unsubscribe-form')
    );
  }
} else {
  // Dev mode allows us to work on all pages easily with react router
  ReactDOM.render( 
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider> 
    </React.StrictMode>,
    document.getElementById('root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();